<template id="DirecionamentoVending">
    <v-ons-page id="DirecionamentoVendingPage">
      <v-ons-row width="90%" style="align-itens:center">
        <v-ons-col>
          <img src="../assets/img/logo.png" width="200px" style="margin:20px; padding-top:20px">
          <h3  style="  font-size:20px;">Agora é só ir até a vending<br>e apontar sua camera para o QrCode da máquina.</h3>
          <img src="../assets/img/vending.png" width="150px" style="margin:20px;">
          <v-ons-button class="botao" @click="openLeitorQrCode()">Ok</v-ons-button>
        </v-ons-col>
      </v-ons-row>
    </v-ons-page>
</template>
<style scoped>


</style>
<script>
import LeitorQrCodeVendingVue from './LeitorQrCodeVending.vue';

export default {
  name: 'DirecionamentoVending',
  key: 'DirecionamentoVending',
  data() {
    return {

    };
  },
   props: ['pageStack'],
  methods: {
    openLeitorQrCode(){ 
        this.$emit('push',LeitorQrCodeVendingVue);
    }
  }
}
</script>